import { render } from "./FirstTimeDentist.vue?vue&type=template&id=d1ad071c"
import script from "./FirstTimeDentist.vue?vue&type=script&lang=js"
export * from "./FirstTimeDentist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__